import { useState, useEffect, useMemo } from "react";
import "./EnterManual.css";
import { FiX } from "react-icons/fi";
import { authFetch } from "./authFetch";





function normalizeClinic(str) {
  return str
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}


const LETTERS = [
  "#","A","B","C","D","E","F","G","H","I","J","K","L",
  "M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"
];

//  REQUIRED STAR COMPONENT
const Required = () => <span className="required">*</span>;

// Strict datetime format
const DATE_REGEX =
  /^([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[12]\d|3[01])\/\d{4}\s([1-9]|0[1-9]|1[0-2]):[0-5]\d:[0-5]\d\s(AM|PM)$/;

// F-02/03: date-only regex for Order Received
const DATE_ONLY_REGEX = /^([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[12]\d|3[01])\/\d{4}$/;

//const DATE_REGEX = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}\s(0?[1-9]|1[0-2]):[0-5]\d:[0-5]\d\s(AM|PM)$/;
const DOB_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;



export default function EnterManual() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  // -----------------------
  // CLINIC SEARCH + MODAL
  // -----------------------
  const [allClinics, setAllClinics] = useState([]);
  const [clinic, setClinic] = useState("");
  const [clinicModalOpen, setClinicModalOpen] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState("");
  const [letterClinics, setLetterClinics] = useState([]);

  // New clinic modal
  const [newClinicOpen, setNewClinicOpen] = useState(false);
  const [newClinicName, setNewClinicName] = useState("");

  // -----------------------
  // FORM FIELDS
  // -----------------------
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const [dob, setDob] = useState("");
  const [status, setStatus] = useState("In-Process");

  const [orderReceived, setOrderReceived] = useState(""); // F-02/03: shipDate renamed to orderReceived
  // F-12: const [deliveryDate, setDeliveryDate] = useState("");
  const [notes, setNotes] = useState("");
  const [physician, setPhysician] = useState(""); // F-04

  const [trackingRows, setTrackingRows] = useState([""]);
  const [orderCreated, setOrderCreated] = useState("");


  // Validation errors
 // const [shipErr, setShipErr] = useState("");
  //const [delErr, setDelErr] = useState("");

  // -----------------------
// ERROR DISPLAY TOGGLE
// -----------------------
const [showErrors, setShowErrors] = useState(false);
const [showDateWarning, setShowDateWarning] = useState(false);
const [pendingPayload, setPendingPayload] = useState(null);


  // -----------------------
  // LOAD CLINICS
  // -----------------------
  useEffect(() => {
    async function load() {
      try {
        const res = await authFetch(`${API_BASE}/admin/clinics`);
        const data = await res.json();
        const names = (data.items || []).map(i => i.clinicName);
        names.sort((a, b) => a.localeCompare(b));
        setAllClinics(names);
      } catch (e) {
        console.error("Failed to load clinics", e);
      }
    }
    load();
  }, [API_BASE]);

  // -----------------------
  // LETTER CLICK
  // -----------------------
  function handleLetterClick(letter) {
    setSelectedLetter(letter);

    let list = [];
    if (letter === "#") {
      list = allClinics.filter(c => !/^[A-Za-z]/.test(c));
    } else {
      list = allClinics.filter(c => c.toUpperCase().startsWith(letter));
    }

    setLetterClinics(list);
    setClinicModalOpen(true);
  }

  // -----------------------
  // TRACKING ROW METHODS
  // -----------------------
  // Always keeps stable state — no accidental wipeouts
function updateTracking(i, value) {
  setTrackingRows(prev => {
    const copy = [...prev];
    copy[i] = value;
    return copy;
  });
}

// Add a new empty row ONLY if the last row has content
function addTrackingRow() {
  setTrackingRows(prev => {
    if (prev[prev.length - 1].trim() === "") return prev; // do nothing
    return [...prev, ""];
  });
}

// Remove row SAFELY (never delete last empty row)
function removeTrackingRow(i) {
  setTrackingRows(prev => {
    const copy = prev.filter((_, idx) => idx !== i);
    return copy.length === 0 ? [""] : copy;
  });
}


  // -----------------------
  // STATUS RULES (YOUR EXACT TABLE)
  // -----------------------
  function validateDates(st, ship, delv) {
    let sErr = "";
    let dErr = "";

    if (st === "Cancelled") return { sErr: "", dErr: "" };

    if (st === "Pending" || st === "In-Process") {
      if (delv) dErr = "Delivery date not allowed.";
      if (ship && !DATE_REGEX.test(ship)) sErr = "Invalid Ship Date.";
      return { sErr, dErr };
    }

    if (st === "Shipped") {
      if (!ship) sErr = "Ship Date required.";
      else if (!DATE_REGEX.test(ship)) sErr = "Invalid Ship Date.";
      return { sErr, dErr };
    }

    if (st === "Out for Delivery") {
      if (!ship) sErr = "Ship Date required.";
      else if (!DATE_REGEX.test(ship)) sErr = "Invalid Ship Date.";

      if (!delv) dErr = "Delivery Date required.";
      else if (!DATE_REGEX.test(delv)) dErr = "Invalid Delivery Date.";

      return { sErr, dErr };
    }

    if (st === "Delivered") {
      if (!ship) sErr = "Ship Date required.";
      else if (!DATE_REGEX.test(ship)) sErr = "Invalid Ship Date.";

      if (!delv) dErr = "Delivery Date required.";
      else if (!DATE_REGEX.test(delv)) dErr = "Invalid Delivery Date.";

      return { sErr, dErr };
    }

    return { sErr, dErr };
  }

  function isValidDOB(dob) {
    if (!DOB_REGEX.test(dob.trim())) return false;
    const entered = new Date(dob.trim());
    return entered <= new Date();
  }

function invalidRequired(value) {
  return showErrors && (!value || value.trim() === "");
}

function invalidDOB(value) {
  if (!showErrors) return false;
  if (!DOB_REGEX.test(value.trim())) return true;
  const entered = new Date(value.trim());
  return entered > new Date();
}

function dobErrorMsg(value) {
  if (!value || !value.trim()) return "Date of Birth is required.";
  if (!DOB_REGEX.test(value.trim())) return "Invalid format. Use YYYY-MM-DD";
  const entered = new Date(value.trim());
  if (entered > new Date()) return "Date of Birth cannot be in the future.";
  return "";
}

function invalidShip(required, value) {
  return showErrors && required && (!value || !DATE_REGEX.test(value.trim()));
}

// F-02/03: validate Order Received field
function invalidOrderReceived(value) {
  if (!showErrors) return false;
  if (!value || !value.trim()) return true;
  if (!DATE_ONLY_REGEX.test(value.trim())) return true;
  const parts = value.trim().split("/");
  const entered = new Date(parts[2], parts[0] - 1, parts[1]);
  return entered > new Date();
}

function orderReceivedErrorMsg(value) {
  if (!value || !value.trim()) return "Order Received date is required.";
  if (!DATE_ONLY_REGEX.test(value.trim())) return "Invalid format. Use M/D/YYYY";
  const parts = value.trim().split("/");
  const entered = new Date(parts[2], parts[0] - 1, parts[1]);
  if (entered > new Date()) return "Order Received date cannot be in the future.";
  return "";
}

// F-12: invalidDelivery removed
// function invalidDelivery(required, value) {
//   return showErrors && required && (!value || !DATE_REGEX.test(value.trim()));
// }


  // -----------------------
  // SAVE DISABLED LOGIC
  // -----------------------
 const saveDisabled = useMemo(() => {
  if (!clinic) return true;
  if (!firstName.trim()) return true;
  if (!lastName.trim()) return true;
  if (!isValidDOB(dob)) return true;
  if (!orderCreated.trim()) return true;
  if (!DATE_REGEX.test(orderCreated.trim())) return true;
  // future date check for Sales Order Created
  const ocParts = orderCreated.trim().split(/[\s/:]+/);
  const ocDate = new Date(ocParts[2], ocParts[0] - 1, ocParts[1]);
  if (ocDate > new Date()) return true;

  // F-02/03: validate Order Received as date-only
  if (!orderReceived.trim()) return true;
  if (!DATE_ONLY_REGEX.test(orderReceived.trim())) return true;
  const parts = orderReceived.trim().split("/");
  const entered = new Date(parts[2], parts[0] - 1, parts[1]);
  if (entered > new Date()) return true;
  return false;
}, [
  clinic,
  firstName,
  lastName,
  dob,
  orderCreated,
  status,
  orderReceived, // F-02/03: shipDate → orderReceived
  // F-12: deliveryDate removed
]);


  // -----------------------
  // SUBMIT PAYLOAD (called after confirmation)
  // -----------------------
async function submitPayload(payload) {
  try {
    const res = await authFetch(`${API_BASE}/admin/manual-entry`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    if (data.updated) {
      alert("Order updated successfully!");
    } else if (data.created) {
      alert("Order created successfully!");
    } else {
      alert("Error: " + (data.error || "Failed to save entry"));
      return;
    }

    // Reset
    setClinic("");
    setFirstName("");
    setLastName("");
    setDob("");
    setOrderCreated("");
    setStatus("In-Process");
    setOrderReceived("");
    setNotes("");
    setPhysician(""); // F-04
    setTrackingRows([""]);
    setShowErrors(false);
    setPendingPayload(null);
    setShowDateWarning(false);

  } catch (e) {
    alert("Request failed.");
  }
}

  // -----------------------
  // SAVE ENTRY
  // -----------------------
async function save() {
  setShowErrors(true);
  await new Promise(resolve => setTimeout(resolve, 0));

  if (saveDisabled) return;

  const patientName = `${lastName.trim()} ${firstName.trim()[0] || ""}`.trim(); // F-01: Last Name + First Initial

  // CLEAN TRACKING BEFORE SENDING
  const cleanedTracking = trackingRows
    .map(t => t.trim())
    .filter(t => t.length > 0);

  //console.log("CLEANED TRACKING:", cleanedTracking);

  const payload = {
    clinicName: clinic,
    patientName,
    dob,
    order_created: orderCreated.trim(),
    status,
    order_received: orderReceived.trim(), // F-02/03: shipDate → order_received
    // F-12: deliveryDate removed
    deliveryDate: "",
    comments: notes,
    physician: physician.trim(), // F-04
    trackingLinks:
      status === "Cancelled"
        ? []
        : cleanedTracking
  };

  // Compare Sales Order Created date vs Order Received date
  const orderCreatedDateOnly = orderCreated.trim().split(" ")[0];
  if (orderCreatedDateOnly !== orderReceived.trim()) {
    setPendingPayload(payload);
    setShowDateWarning(true);
    return;
  }

  await submitPayload(payload);
}


  // -----------------------
  // RENDER
  // -----------------------
  return (
    <>
      {/* ======================== DATE WARNING MODAL ======================== */}
      {showDateWarning && (
        <div className="modal-overlay">
          <div className="clinic-modal">
            <div className="modal-header">
              <span>Date Mismatch Warning</span>
              <button className="modal-close-btn" onClick={() => setShowDateWarning(false)}>×</button>
            </div>
            <p style={{ fontSize: "15px", color: "#374151", padding: "0 16px" }}>
              The Order Received date <strong>({pendingPayload?.order_received})</strong> is different 
              from the Sales Order Created date <strong>({pendingPayload?.order_created?.trim().split(" ")[0]})</strong>.
              <br /><br />
              Do you want to proceed or go back and change it?
            </p>
            <div className="delete-modal-footer">
              <button
                className="proceed-confirm-btn"
                onClick={() => {
                  setShowDateWarning(false);
                  submitPayload(pendingPayload);
                }}
              >
                Proceed
              </button>
              <button
                className="delete-cancel-btn"
                onClick={() => {
                  setShowDateWarning(false);
                  setPendingPayload(null);
                }}
              >
                Go Back
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ======================== CLINIC SELECT MODAL ======================== */}
      {clinicModalOpen && (
        <div className="modal-overlay">
          <div className="clinic-modal">

            <div className="modal-header">
              <span>Clinics starting with "{selectedLetter}"</span>
              <button
                className="modal-close-btn"
                onClick={() => setClinicModalOpen(false)}
              >
                ×
              </button>
            </div>

            <div className="clinic-modal-scroll">
              {letterClinics.length === 0 ? (
                <div className="modal-empty">No clinics found</div>
              ) : (
                letterClinics.map((name, i) => (
                  <div
                    key={i}
                    className="clinic-modal-item"
                    onClick={() => {
                      setClinic(name);
                      setClinicModalOpen(false);
                    }}
                  >
                    {name}
                  </div>
                ))
              )}
            </div>

            <div className="modal-footer">
              <button
                className="modal-close"
                onClick={() => setClinicModalOpen(false)}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ======================== ADD CLINIC MODAL ======================== */}
      {newClinicOpen && (
        <div className="em-modal-overlay">
          <div className="em-modal">

            <div className="em-modal-header">
              <span>Add New Clinic</span>
              <button
                className="em-close-btn"
                onClick={() => setNewClinicOpen(false)}
              >
                ×
              </button>
            </div>

            <input
              className="em-modal-input"
              placeholder="Enter clinic name"
              value={newClinicName}
              onChange={(e) => setNewClinicName(e.target.value)}
            />

            <div className="em-modal-footer">
              <button
                className="em-primary-btn"
                onClick={() => {
                  const cleaned = newClinicName.trim();
                  if (!cleaned) return;
                  setClinic(cleaned);
                  setNewClinicName("");
                  setNewClinicOpen(false);
                }}
              >
                Save Clinic
              </button>

              <button
                className="em-secondary-btn"
                onClick={() => setNewClinicOpen(false)}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ======================== MAIN FORM ======================== */}
      <div className="manual-wrapper">
        <h2>Enter Manual Order</h2>

        {/* Alphabet */}
        <div className="alphabet-wrapper">
          <div className="alphabet-bar alphabet-inside">
            {LETTERS.map(letter => (
              <button
                key={letter}
                className="letter-btn"
                onClick={() => handleLetterClick(letter)}
              >
                {letter}
              </button>
            ))}
          </div>
        </div>

        {/* Clinic Actions */}
        <div className="clinic-actions">

          <input
            className="clinic-search-input"
            placeholder="Search or select a clinic"
            value={clinic}
            onChange={(e) => setClinic(e.target.value)}
          />

          <button
  className="btn-premium"
  onClick={() => {
    if (!clinic.trim()) return alert("Enter clinic name");

    const inputNorm = normalizeClinic(clinic);

    const match = allClinics.find(
      c => normalizeClinic(c) === inputNorm
    );

    if (match) setClinic(match);
    else alert("Clinic not found");
  }}
>
  Search
</button>


          <button
            className="btn-premium add-clinic-btn"
            onClick={() => setNewClinicOpen(true)}
          >
            + Add New Clinic
          </button>

        </div>

        {/* FORM */}
        <div className="form-grid">

          {/* ROW 1 */}
          <div className="row">

            <div className="form-block">
              <label>
                Clinic <Required />
              </label>
              <input
  value={clinic}
  placeholder="Select clinic using alphabet bar"
  disabled
  className={invalidRequired(clinic) ? "invalid" : ""}
/>

            </div>

            <div className="form-block">
              <label>
                Patient First Name <Required />
              </label>
              <input
  value={firstName}
  onChange={e => setFirstName(e.target.value)}
  className={invalidRequired(firstName) ? "invalid" : ""}
/>


            </div>

          </div>

          {/* ROW 2 */}
          <div className="row">

            <div className="form-block">
              <label>
                Patient Last Name <Required />
              </label>
             <input
  value={lastName}
  onChange={e => setLastName(e.target.value)}
  className={invalidRequired(lastName) ? "invalid" : ""}
/>

            </div>

         <div className="form-block">
  <label>
    Date of Birth <Required />
  </label>
  <input
    value={dob}
    onChange={e => setDob(e.target.value)}
    placeholder="YYYY-MM-DD"
    className={invalidDOB(dob) ? "invalid" : ""}
  />
  {showErrors && invalidDOB(dob) && (
    <small className="error-text" style={{color: "red"}}>
      {dobErrorMsg(dob)}
    </small>
  )}
  <small className="hint-text">Example: 1990-05-15</small>
</div>

<div className="form-block">
  <label>
    Sales Order Created <Required />
  </label>
  <input
    value={orderCreated}
    onChange={e => setOrderCreated(e.target.value)}
    placeholder="M/D/YYYY HH:MM:SS AM/PM"
    className={
  showErrors && (!orderCreated.trim() || !DATE_REGEX.test(orderCreated.trim()) || (() => {
    const p = orderCreated.trim().split(/[\s/:]+/);
    return new Date(p[2], p[0]-1, p[1]) > new Date();
  })()) ? "invalid" : ""
}
  />
  {showErrors && (!orderCreated.trim() || !DATE_REGEX.test(orderCreated.trim())) && (
    <small className="error-text" style={{color: "red"}}>
      {!orderCreated.trim() ? "Sales Order Created is required." : "Invalid format. Use M/D/YYYY HH:MM:SS AM/PM"}
    </small>
  )}
  {showErrors && orderCreated.trim() && DATE_REGEX.test(orderCreated.trim()) && (() => {
    const p = orderCreated.trim().split(/[\s/:]+/);
    return new Date(p[2], p[0]-1, p[1]) > new Date();
  })() && (
    <small className="error-text" style={{color: "red"}}>
      Sales Order Created date cannot be in the future.
    </small>
  )}
  <small className="hint-text">
    Example: 11/26/2025 2:43:47 PM
  </small>
</div>


          </div>

          {/* ROW 3 — STATUS + SHIP DATE */}
          <div className="row">

            <div className="form-block">
              <label>
                Status <Required />
              </label>
              <select value={status} onChange={e => setStatus(e.target.value)}>
                <option>In-Process</option>
                <option>Pending</option>
                <option>Shipped</option>
                <option>Out for Delivery</option>
                <option>Delivered</option>
                <option>Cancelled</option>
              </select>
            </div>

            {/* Ship Date Visibility Rules */}
            {status === "Cancelled" ? (
              <div className="form-block empty"></div>
            ) : (
              <div className="form-block">
                <label>
                  Order Received <Required /> {/* F-02/03: always required */}
                </label>
                <input
  value={orderReceived}
  onChange={e => setOrderReceived(e.target.value)}
  placeholder="M/D/YYYY"
  className={invalidOrderReceived(orderReceived) ? "invalid" : ""}
/>
{showErrors && invalidOrderReceived(orderReceived) && (
  <small className="error-text" style={{color: "red"}}>
    {orderReceivedErrorMsg(orderReceived)}
  </small>
)}
<small className="hint-text">Example: 11/26/2025</small>

              </div>
            )}

          </div>

          {/* ROW 4 — DELIVERY DATE - F-12: Removed per Trey request
          <div className="row">
            ...delivery date input removed...
          </div>
          */}

          {/* ROW 5 — NOTES */}
          <div className="row full">
            <div className="form-block">
              {/* F-04: Physician field */}
              <label>Physician</label>
              <input
                type="text"
                value={physician}
                onChange={e => setPhysician(e.target.value)}
                placeholder="Last Name, First Name"
              />

              <label>Notes</label>
              <textarea
                value={notes}
                onChange={e => setNotes(e.target.value)}
                placeholder="Optional notes"
              />
            </div>
          </div>

          {/* ROW 6 — TRACKING */}
          {status !== "Cancelled" && (
            <div className="row full">
              <div className="form-block">
                <label>Tracking Numbers</label>

                {trackingRows.map((t, i) => (
                  <div key={i} className="tracking-row">
                    <input
                      className="tracking-input"
                      value={t}
                      onChange={e => updateTracking(i, e.target.value)}
                      placeholder="Tracking number"
                    />
                    <FiX
                      className="remove-tracking-btn"
                      onClick={() => removeTrackingRow(i)}
                    />
                  </div>
                ))}

                <button className="add-tracking-btn" onClick={addTrackingRow}>
                  + Add Tracking Number
                </button>
              </div>
            </div>
          )}

        </div>

        {/* SAVE BUTTON */}
        <div className="save-btn-wrapper">
          <button
            className="save-btn"
            onClick={save}
            //disabled={saveDisabled}
          >
            Save
          </button>
        </div>

      </div>
    </>
  );
}
